import { useEffect } from 'react'
import { useCart } from 'medusa-react'
import { medusaClient } from '@lib/config'
import socket from '@lib/socket'

export const PROMOTION_APPLY = 'PROMOTION_APPLY'

export const AVOCADO_APPLY = 'AVOCADO_APPLY'

const useListenCartChange = () => {
  const { cart, setCart } = useCart()

  const cartId: string = cart ? cart.id : ''

  useEffect(() => {
    if (cartId) {
      console.log('Listen event cart with cartId:', cartId)

      // Need socket off to clear old event listener because when user go to new page and back here useEffect will run again and run listen cart change more time
      socket.off(cartId)
      socket.off('connect_error')

      socket.on(cartId, async (value: any) => {
        if (
          (value.name == PROMOTION_APPLY || value.name == AVOCADO_APPLY) &&
          value.status == true
        ) {
          const data = await medusaClient.carts.retrieve(cartId as string)
          console.log('Reset cart timeout with data:', data)
          setCart(data.cart)
        }
      })

      socket.on('connect_error', (error: any) => {
        console.error('Socket connection error:', error)
      })
    }
  }, [cartId, setCart])
}

export default useListenCartChange
